import api from '@/api/offerLetter'

const state = {

}

const actions = {
  getOfferLetterTemplateList (context, params) {
    return api.getOfferLetterTemplateList(params)
  },
  getOfferLetterTemplateInfoById (context, templateId) {
    return api.getOfferLetterTemplateInfoById(templateId)
  },
  createOfferLetterTemplate (context, params) {
    return api.createOfferLetterTemplate(params)
  },
  updateOfferLetterTemplate (context, params) {
    return api.updateOfferLetterTemplate(params)
  },
  getOfferLetterTemplateFieldList (context, params) {
    return api.getOfferLetterTemplateFieldList(params)
  },
  getOfferLetterTemplateFieldInfoById (context, fieldId) {
    return api.getOfferLetterTemplateFieldInfoById(fieldId)
  },
  createOfferLetterTemplateField (context, params) {
    return api.createOfferLetterTemplateField(params)
  },
  updateOfferLetterTemplateField (context, params) {
    return api.updateOfferLetterTemplateField(params)
  },
  moveTemplateFieldOrder (context, params) {
    return api.moveTemplateFieldOrder(params)
  },
  getOfferLetterInviteRecordList (context, params) {
    return api.getOfferLetterInviteRecordList(params)
  },
  getOfferLetterInviteRecordInfoById (context, params) {
    return api.getOfferLetterInviteRecordInfoById(params)
  },
  saveCandidateOfferLetterOperate (context, params) {
    return api.saveCandidateOfferLetterOperate(params)
  },
  createExportOfferInviteRecordTask (context, params) {
    return api.createExportOfferInviteRecordTask(params)
  },
  getExportOfferInviteRecordTaskInfo (context, params) {
    return api.getExportOfferInviteRecordTaskInfo(params)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
